/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { ThunkDispatch, ReduxState } from '@/types/redux'
import { getCertificateAuthority } from '@/reducers/certificateAuthority'
import { fetchCertificateAuthorityRequest } from '@/reducers/asyncRequests/registry'

import { fetchCertificateAuthority } from '../../../../actions/certificateAuthority'

import CertificateAuthority from './CertificateAuthority'

import type { StateProps, ConsumerProps, DispatchProps } from './types'

const mapStateToProps = (state: ReduxState, { deployment }: ConsumerProps): StateProps => ({
  certificateAuthority: getCertificateAuthority(state, deployment.id),
  fetchCertificateAuthorityRequest: fetchCertificateAuthorityRequest(state),
})

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  fetchCertificateAuthority: (deploymentId: string) =>
    dispatch(fetchCertificateAuthority(deploymentId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(CertificateAuthority)
